var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.37,29c8,0,14.5-6.5,14.5-14.5S58.37,0,50.37,0s-14.5,6.5-14.5,14.5,6.5,14.5,14.5,14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m57.98,36.69h-15.96c-10.8,0-19.58,8.78-19.58,19.58v40.77c0,1.64,1.33,2.96,2.96,2.96h49.19c1.64,0,2.96-1.33,2.96-2.96v-40.77c0-10.8-8.78-19.58-19.58-19.58Zm8.57,22.58l-18.83,19.01c-.56.56-1.31.88-2.1.88s-1.55-.32-2.1-.88l-8.63-8.71c-1.15-1.16-1.14-3.04.02-4.19,1.16-1.15,3.04-1.14,4.19.02l6.53,6.59,16.73-16.89c1.15-1.16,3.03-1.17,4.19-.02,1.16,1.15,1.17,3.03.02,4.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAssignment);
export default __webpack_public_path__ + "static/media/userAssignment.9b7aa0d15f0ce58f3d4b19975799766c.svg";
export { ForwardRef as ReactComponent };